import { Box, Container, Grid, Group, NullLogo, Stack, Text } from "@repo/ui/core";
import { IconBrandGitlab, IconBrandLinkedin } from "@repo/ui/icons";
import { Link } from "react-router";
import styles from "@styles/site.module.css";

const footerLinks = {
  products: [
    { label: "Platform Overview", to: "/platform" },
    { label: "Android Builds", to: "/products/android-builds" },
    { label: "Web Emulators", to: "/products/emulators" },
    { label: "Remote Development", to: "/products/remote-dev" },
    { label: "Automated Testing", to: "/products/testing" },
  ],
  solutions: [
    { label: "Engineering Leaders", to: "/solutions/engineering-leaders" },
    { label: "Developers", to: "/solutions/developers" },
  ],
  company: [{ label: "Contact", to: "/contact" }],
};

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <Container size="xl">
        <Grid gutter="xl">
          <Grid.Col span={{ base: 12, md: 5 }}>
            <Stack gap="md">
              <Link to="/" aria-label="Null Autos home" style={{ display: "inline-block" }}>
                <NullLogo w={72} />
              </Link>
              <Text size="sm" c="dimmed" maw={300} lh={1.65}>
                The CI/CD platform for software-defined vehicles. Build, test, and deploy Android
                Automotive from your browser.
              </Text>
              <Group gap="sm" mt={4}>
                <a
                  className={styles.socialLink}
                  href="https://gitlab.com/null-autos"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Null Autos on GitLab"
                >
                  <IconBrandGitlab size={18} stroke={1.5} />
                </a>
                <a
                  className={styles.socialLink}
                  href="https://linkedin.com/company/null-autos"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Null Autos on LinkedIn"
                >
                  <IconBrandLinkedin size={18} stroke={1.5} />
                </a>
              </Group>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 6, sm: 4, md: 3 }}>
            <div className={styles.footerHeading}>Products</div>
            {footerLinks.products.map((link) => (
              <Link key={link.to} className={styles.footerLink} to={link.to}>
                {link.label}
              </Link>
            ))}
          </Grid.Col>

          <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
            <div className={styles.footerHeading}>Solutions</div>
            {footerLinks.solutions.map((link) => (
              <Link key={link.to} className={styles.footerLink} to={link.to}>
                {link.label}
              </Link>
            ))}
          </Grid.Col>

          <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
            <div className={styles.footerHeading}>Company</div>
            {footerLinks.company.map((link) => (
              <Link key={link.to} className={styles.footerLink} to={link.to}>
                {link.label}
              </Link>
            ))}
          </Grid.Col>
        </Grid>

        <Box className={styles.footerBottom}>
          <span>&copy; {new Date().getFullYear()} Null Autos Inc. All rights reserved.</span>
          <Group gap="lg">
            <Link className={styles.footerLink} to="/privacy" style={{ padding: 0 }}>
              Privacy
            </Link>
            <Link className={styles.footerLink} to="/terms" style={{ padding: 0 }}>
              Terms
            </Link>
          </Group>
        </Box>
      </Container>
    </footer>
  );
}
